/*
 *  Copyright 2010-2016 FinTech Neo AS ( fintechneo.com )- All rights reserved
 */

import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoParams } from './info';
import { OrgbrainLayoutService } from '../orgbrain-layout.service';

@Component({
  templateUrl: 'multichoicedialog.component.html',
  styleUrls: ['dialog.component.scss'],
    standalone: false
})
export class MultiChoiceDialogComponent {
  data = inject<InfoParams>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<MultiChoiceDialogComponent>>(MatDialogRef);
  layout = inject(OrgbrainLayoutService);

  trustedHtml: SafeHtml;

  constructor() {
    const data = this.data;
    const sanitizer = inject(DomSanitizer);

    this.trustedHtml = sanitizer.bypassSecurityTrustHtml(data.message);
  }

  select(option) {
    this.dialogRef.close(option);
  }
  getColor(option) {
    if (!option.style) {
      return option.key === 'CANCEL' ? 'secondary' : 'primary';
    } else {
      return option.style === 'primary' ? 'primary' : 'secondary';
    }
  }

  getStyle(option) {
    switch (option.style) {
      case 'primary':
        return 'color:#FFF; background-color:#0097a7';
      case 'outline':
        return 'border:1px solid #0097a7; color:#0097a7';
      case 'blank':
        if (!this.layout.mobile) {
          return 'border:none,min-width:0px !important;color:#0097a7;margin-right: -5px;';
        } else {
          return 'border:none,min-width:0px !important;color:#0097a7;';
        }
    }
  }
}
